import React from 'react'

import { Blanket } from '@/shared/components/ui/blanket'
import { Loader } from '@/shared/components/ui/loader'

export default function WidgetLoadingState({
	isTinted,
}: {
	isTinted?: boolean
}) {
	return (
		<Blanket
			className='absolute flex items-center justify-center rounded-xl bg-white/50 backdrop-blur-lg dark:bg-black/50'
			isTinted={isTinted}
		>
			<Loader />
		</Blanket>
	)
}
